import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import {
  FormControlLabel,
  Checkbox,
  Button,
  Dialog,
  IconButton,
  Typography,
  Box,
  AppBar,
  Toolbar
} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import { useCookies } from 'react-cookie';
import RTLTranslate from '../../components/rtl-translate';
import { update } from '../../services/Airtable';
import { isEmpty } from '../../utils';
import themeStyles from '../../theme-css';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="subtitle2">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2)
  }
}))(MuiDialogContent);

export default function StartModal({ show }) {
  const classes = themeStyles();
  const clientInfo = useSelector((state) => state.globalState.clientInfo);
  const clientID = useSelector((state) => state.globalState.clientID);
  const allConfigs = useSelector((state) => state.globalState.allConfigs);
  const [open, setOpen] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const [cookies, setCookie] = useCookies(['show']);

  const translateHebrewText = (key) => {
    if (allConfigs.Translation && allConfigs.Translation[key]) {
      return allConfigs.Translation[key];
    } else {
      return key;
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const dontShowAgainAction = async () => {
    setDontShowAgain(true);
    setOpen(false);
    var response = await update('Clients', clientID, {
      'Skip Splash': 'Yes'
    });
  };

  const openModal = (type) => {
    if (type && type != 'fromNav') {
      var date = new Date();
      date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
      setCookie('splash_displayed', true, { path: '/', expires: date });
    }
    setOpen(true);
  };

  useEffect(() => {
    if (!isEmpty(clientInfo)) {
      if (
        cookies &&
        cookies.splash_displayed &&
        cookies.splash_displayed === 'true'
      ) {
        return;
      }
      if (!clientInfo['Skip Splash']) {
        openModal();
      }
      if (
        clientInfo &&
        (isEmpty(clientInfo['Skip Splash']) ||
          clientInfo['Skip Splash'] !== 'Yes')
      ) {
        openModal();
      }
    }
  }, [clientInfo]);

  return (
    <div>
      {show === 'nav' ? (
        <Box style={{ paddingRight: 40, paddingTop: 20, paddingBottom: 20 }}>
          <Button variant="outlined" onClick={() => openModal('fromNav')}>
            {translateHebrewText('Guiding Video')}
          </Button>
        </Box>
      ) : null}

      <Dialog
        fullScreen
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          <AppBar className={classes.addNewLeadappBar}>
            <Toolbar>
              <Typography variant="h6" className={classes.addNewLeadtitle}>
                <RTLTranslate text="Splash Title" />
              </Typography>
              <IconButton edge="start" color="inherit" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
        </DialogTitle>
        <DialogContent dividers>
          <Box p={1} mt={2} className={classes.mianModalWrapper}>
            <Typography
              variant="subtitle2"
              gutterBottom
              style={{ marginBottom: 10 }}
            >
              <RTLTranslate text="Splash Text" />
            </Typography>
            <div className={classes.modalIframeWrapper}>
              <iframe
                className={classes.modalIframe}
                src="https://www.youtube.com/embed/1mogwCVOkUw"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen="true"
              ></iframe>
            </div>
          </Box>
        </DialogContent>
        <Box p={1} display="flex" justifyContent="center">
          <FormControlLabel
            control={
              <Checkbox
                checked={dontShowAgain}
                onChange={dontShowAgainAction}
                color="primary"
              />
            }
            label={<RTLTranslate text="Splash Skip" />}
          />
        </Box>
      </Dialog>
    </div>
  );
}
